import { render, staticRenderFns } from "./gift-single.vue?vue&type=template&id=c11653ce&scoped=true&"
import script from "./gift-single.vue?vue&type=script&lang=js&"
export * from "./gift-single.vue?vue&type=script&lang=js&"
import style0 from "./gift-single.vue?vue&type=style&index=0&id=c11653ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c11653ce",
  null
  
)

export default component.exports